var path = '/pages/dashboard/views/dashboard.tpl.html';
var html = "<section ng-if=\"vm.loading\">\n    <div class=\"dashboard-empty\">\n        <div class=\"pacman\">\n            <i class=\"fal fa-sync fa-spin\"></i>\n            <h2>Loading data</h2>\n        </div>\n    </div>\n</section>\n\n<!--<dashboard-default ng-if=\"!vm.loading && !vm.dashboard\"></dashboard-default>-->\n<dashboard-oktoberfest ng-if=\"!vm.loading && !vm.dashboard\"></dashboard-oktoberfest>\n<dashboard-schuetzenfestzelt ng-if=\"!vm.loading && vm.dashboard === 'schuetzenfestzelt'\"></dashboard-schuetzenfestzelt>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/views/dashboard.tpl.html
// module id = 2240
// module chunks = 1